export class ActivityModel {
  id: string;
  specifics?: string;

  constructor() {
    this.id = '';
  }
}
